import { FunctionComponent } from "react";
import { PublicComponentProps } from "./PublicComponentProps";

const SkipToMainContentAnchor: FunctionComponent<
  PublicComponentProps<Record<string, unknown>>
> = () => <span id="skip-main" tabIndex={-1} />;

export default SkipToMainContentAnchor;
